import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/solid';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon as ExclamationCircleSolidIcon } from '@heroicons/react/24/solid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Alert = function Alert(_ref) {
  var wrapperStyling = _ref.wrapperStyling,
      icon = _ref.icon,
      textStyling = _ref.textStyling,
      text = _ref.text,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'error' : _ref$variant;
  return /*#__PURE__*/_jsxs(AlertWrapper, {
    wrapperStyling: wrapperStyling,
    variant: variant,
    children: [icon ? icon : variant ? {
      success: /*#__PURE__*/_jsx(CheckCircleIcon, {
        className: "text-green-700 min-w-[18px] min-h-[18px] max-w-[18px] max-h-[18px]"
      }),
      error: /*#__PURE__*/_jsx(ExclamationCircleIcon, {
        className: "relative text-red-600 min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px]"
      }),
      info: /*#__PURE__*/_jsx(ExclamationCircleSolidIcon, {
        className: "text-yellow-700 rotate-180 min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px]"
      }),
      warning: /*#__PURE__*/_jsx(InformationCircleIcon, {
        className: "fill-orange-700 min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px]"
      })
    }[variant] : null, /*#__PURE__*/_jsx(StyledText, {
      textStyling: textStyling,
      variant: variant,
      children: text
    })]
  });
};
export var AlertWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "alert__AlertWrapper",
  componentId: "sc-aufu0n-0"
})(function (_ref2) {
  var twStyle = _ref2.wrapperStyling,
      variant = _ref2.variant;
  return [{
    "display": "flex",
    "width": "100%",
    "maxWidth": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "gap": "0.5rem",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "padding": "0.75rem",
    "@media (min-width: 1024px)": {
      "maxWidth": "42rem",
      "padding": "0.75rem"
    }
  }, variant ? {
    success: {
      "alignItems": "center",
      "borderRadius": "0.375rem",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(51 146 102 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(230 241 236 / var(--tw-bg-opacity))"
    },
    error: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(186 0 31 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))"
    },
    info: {
      "borderLeftWidth": "4px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(245 158 11 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(253 246 178 / var(--tw-bg-opacity))"
    },
    warning: {
      "width": "fit-content",
      "gap": "0.25rem",
      "borderRadius": "0.5rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(158 84 0 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(252 241 230 / var(--tw-bg-opacity))",
      "padding": "0.25rem",
      "@media (min-width: 1024px)": {
        "maxWidth": "100%",
        "gap": "0.25rem",
        "padding": "0.25rem"
      }
    }
  }[variant] : {}].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});
export var StyledText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "alert__StyledText",
  componentId: "sc-aufu0n-1"
})(function (_ref3) {
  var twStyle = _ref3.textStyling,
      variant = _ref3.variant;
  return [{
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "@media (min-width: 1024px)": {
      "fontSize": "0.875rem",
      "lineHeight": "1.313rem"
    }
  }, variant ? {
    success: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 84 45 / var(--tw-text-opacity))"
    },
    error: {
      "--tw-text-opacity": "1",
      "color": "rgb(186 0 31 / var(--tw-text-opacity))"
    },
    info: {
      "--tw-text-opacity": "1",
      "color": "rgb(114 59 19 / var(--tw-text-opacity))"
    },
    warning: {
      "--tw-text-opacity": "1",
      "color": "rgb(158 84 0 / var(--tw-text-opacity))",
      "@media (min-width: 1024px)": {
        "fontSize": "1rem",
        "lineHeight": "1.5rem"
      }
    }
  }[variant] : {}].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});